var map = {
	"./az.json": [
		1206,
		106
	],
	"./en.json": [
		1207,
		107
	],
	"./es-mx.json": [
		1208,
		109
	],
	"./es.json": [
		1209,
		108
	],
	"./tr.json": [
		1210,
		110
	],
	"./widgets/az.json": [
		892,
		8
	],
	"./widgets/en.json": [
		893,
		9
	],
	"./widgets/es-mx.json": [
		894,
		11
	],
	"./widgets/es.json": [
		895,
		10
	],
	"./widgets/tr.json": [
		896,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 788;
module.exports = webpackAsyncContext;